module.exports = __webpack_public_path__ + "static/media/install-svgrepo-com.cb88f8f1.svg";